import React from 'react';
import styles from './index.module.less';

interface IconProps {
  iconName: string;
  imgClass?: any;
}

const Icon: React.FC<IconProps> = ({ iconName, imgClass = styles.img }) => {
  const imgSrc = require(`@/assets/images/${iconName}.png`);
  const srcSet = `
    ${require(`@/assets/images/${iconName}.png`)} 1x,
    ${require(`@/assets/images/${iconName}@2x.png`)} 2x,
    ${require(`@/assets/images/${iconName}@3x.png`)} 3x,
  `;

  return (
    <img src={imgSrc} alt={iconName} className={imgClass} srcSet={srcSet} />
  );
};

export default Icon;
